import React from 'react';

import { DataDisputeReportTable } from 'src/components/reports';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const DataDisputeReportPage: React.FC = () => {
  return (
    <TableDataProvider>
      <DataDisputeReportTable />
    </TableDataProvider>
  );
};
